import ModalClassicLayout from 'context/Modal/layout/Classic';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { NestedFormValues } from 'utils/filters/convertToDotNotation';
import useFilters from './hooks';
import { filterJsonType } from '@/types/filterJson';
import useCardsFilterData from 'hooks/queries/cards/useCardsFilterData';
import { FilterDataDto } from '@/types/utils';

type FiltersPropsType = {
  onSubmit: (values: NestedFormValues) => void;
  onClear: () => void;
  closeModal: () => void;
  formMethods: UseFormReturn<NestedFormValues>;
  filterJson?: filterJsonType[];
} & Parameters<typeof useFilters>[0];

const FilterJsonToComponents = ({
  filterJson,
  filterData,
}: {
  filterJson: filterJsonType[];
  filterData: FilterDataDto;
}) =>
  filterJson.map((filter) => (
    <filter.component
      key={filter.name}
      label={filter.label}
      name={filter.name}
      options={filter.options || (filter.source && filterData[filter.source])}
      {...filter.inputProps}
    >
      {filter.filters && <FilterJsonToComponents filterData={filterData} filterJson={filter.filters} />}
    </filter.component>
  ));

const Filters = ({ closeModal, onSubmit, onClear, formMethods, filterJson, ...hookProps }: FiltersPropsType) => {
  const { components, modalTitle } = useFilters(hookProps);
  const { handleSubmit } = formMethods;
  const { t } = useTranslation();
  const { filterData } = useCardsFilterData();

  return (
    <FormProvider {...formMethods}>
      <ModalClassicLayout
        closeModal={closeModal}
        onSubmit={handleSubmit(onSubmit)}
        submitLabel={t('submit')}
        title={modalTitle}
      >
        <form className="min-w-vw-1/2 lg:min-w-fit" onSubmit={handleSubmit(onSubmit)}>
          <ul className="flex flex-col gap-4">
            {filterJson ? <FilterJsonToComponents filterData={filterData} filterJson={filterJson} /> : components}
          </ul>
          <input className="hidden" type="submit" />
        </form>
      </ModalClassicLayout>
    </FormProvider>
  );
};

export default Filters;
